import api from './api';
import { Kommentar, KommentarEntityTyp, CreateKommentarRequest, UpdateKommentarRequest } from '../types';

// Lesen/Anlegen laufen als Unterressource der Entität, Bearbeiten/Löschen über /kommentare/{id}.
const basePath = (entityType: KommentarEntityTyp, entityId: number): string => {
  switch (entityType) {
    case 'GRAB': return `/graeber/${entityId}/kommentare`;
    case 'KUNDE': return `/kunden/${entityId}/kommentare`;
  }
};

export const kommentarService = {
  getForEntity: async (entityType: KommentarEntityTyp, entityId: number): Promise<Kommentar[]> => {
    const response = await api.get(basePath(entityType, entityId));
    return response.data;
  },
  create: async (entityType: KommentarEntityTyp, entityId: number, data: CreateKommentarRequest): Promise<Kommentar> => {
    const response = await api.post(basePath(entityType, entityId), data);
    return response.data;
  },
  update: async (id: number, data: UpdateKommentarRequest): Promise<Kommentar> => {
    const response = await api.put(`/kommentare/${id}`, data);
    return response.data;
  },
  delete: async (id: number): Promise<void> => {
    await api.delete(`/kommentare/${id}`);
  },
};

export default kommentarService;
